import React from 'react';

import { IconButton } from 'components';
import Modal from 'components/Modal';
import { ButtonV3 } from 'components/ComponentV2';
import { usePartnerships } from 'hooks/usePartnerships';

import styles from './RemovePartnerModal.module.scss';

interface RemovePartnerModalProps {
  open: boolean;
  onClose: () => void;
  invitationId: string;
  societyName: string;
}

export const RemovePartnerModal: React.FC<RemovePartnerModalProps> = (
  props
) => {
  const { open, onClose, invitationId, societyName } = props;

  const { isLoading, removePartner } = usePartnerships();

  const onRemovePartner = async () => {
    const response = await removePartner(invitationId);
    if (response) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      contentClassName={styles.RemovePartnersModal}
    >
      <div className={styles.RemovePartnersModalHeader}>
        <p>Remove Conversation</p>
        <IconButton
          size="small"
          iconName="icon_close"
          onClick={onClose}
          className={styles.closeIcon}
        />
      </div>
      <div className={styles.RemovePartnersModalContent}>
        <p className={styles.info}>
          Are you sure you want to remove <b>{societyName}</b>?
        </p>
      </div>
      <div className={styles.RemovePartnersModalAction}>
        <ButtonV3 color="secondary" onClick={onClose}>
          Cancel
        </ButtonV3>
        <ButtonV3
          color="danger"
          onClick={onRemovePartner}
          isLoading={isLoading}
        >
          Yes, Remove
        </ButtonV3>
      </div>
    </Modal>
  );
};
